"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ripple = void 0;
var Ripple_1 = __importDefault(require("./Ripple"));
exports.Ripple = Ripple_1.default;
exports.default = Ripple_1.default;
//# sourceMappingURL=index.js.map